<ng-container *ngIf="groupedAction.link">
    <a
        class="action-tag focus:not:focus-visible:cmps-cdk-outline-0 {{
            isBest
                ? groupedAction.action?.isBestClassList
                : groupedAction.action?.classList
        }}"
        [class.tag-best]="isBest"
        [routerLink]="groupedAction.linkRouterCommands?.[0]"
        [queryParams]="groupedAction.linkRouterCommands?.[1]?.queryParams"
        [attr.aria-label]="
            (groupedAction.action?.label | translate) +
            (name ? ' — ' + name : '')
        "
        [cmpsTooltipTrigger]="groupedAction.action?.tooltip | translate"
        [openDelay]="300"
        [cmpsBadge]="'' + groupedAction.count"
        [cmpsBadgeHidden]="groupedAction.count <= 1"
        [cmpsBadgeClassName]="groupedAction.action?.badgeBgColor"
    >
        <span class="cmps-cdk-line-clamp-1">{{
            groupedAction.action?.label | translate
        }}</span>
    </a>
</ng-container>

<ng-container *ngIf="groupedAction.button">
    <button
        type="button"
        class="action-tag focus:not:focus-visible:cmps-cdk-outline-0 {{
            isBest
                ? groupedAction.action?.isBestClassList
                : groupedAction.action?.classList
        }}"
        [class.tag-best]="isBest"
        [attr.aria-label]="
            (groupedAction.action?.label | translate) +
            (name ? ' — ' + name : '')
        "
        [cmpsTooltipTrigger]="groupedAction.action?.tooltip | translate"
        [openDelay]="300"
        [cmpsBadge]="'' + groupedAction.count"
        [cmpsBadgeHidden]="groupedAction.count <= 1"
        [cmpsBadgeClassName]="groupedAction.action?.badgeBgColor"
        (click)="groupedAction.buttonClick()"
    >
        <span class="cmps-cdk-line-clamp-1">{{
            groupedAction.action?.label | translate
        }}</span>
    </button>
</ng-container>
